import React from "react";

// Interrupteur partagé (lot 7, 29/09). Sept sites le redessinaient à la main, avec ou sans rôle
// d'accessibilité : même dessin partout — piste marine quand actif, gris-texte sinon, bouton blanc —
// et toujours `role="switch"` + `aria-checked`, pour les lecteurs d'écran et les tests.
// Piste éteinte en gris-texte (décision de Mélilia du 30/09, sur ébauche) : le sable foncé d'avant
// se voyait à peine sur les cartes beiges (1,30:1) et le bouton blanc s'y détachait mal (1,81:1).
export default function Switch({ checked, onChange, testid, title, className = "" }) {
  return (
    <button type="button" role="switch" aria-checked={!!checked} aria-label={title} title={title}
      data-testid={testid} onClick={onChange}
      className={`relative w-11 h-6 rounded-full transition-colors shrink-0 ${checked ? "bg-marine" : "bg-gris-texte"} ${className}`}>
      <span className={`absolute top-0.5 w-5 h-5 rounded-full bg-white transition-all ${checked ? "left-[22px]" : "left-0.5"}`} />
    </button>
  );
}
